import vue from 'vue';

vue.filter('noHtml', text => text.replace(/<[^>]*>?/gm, ''));



// WEBPACK FOOTER //
// ./src/filters/no-html.filter.js